import Modal from 'components/Modal';
import ModalBody from 'components/Modal/ModalBody';
import Paragraph from 'components/Paragraph';
import RoundedButton from 'components/RoundedButton';
import Strong from 'components/Strong';
import useGoBack from 'hooks/useGoBack';
import { useTransferBookingContext } from 'modules/host-transfer-booking/context/TransferBookingContext';
import React from 'react';

const CSS = require('./DeclineTransferModal.module.scss');

function DeclineTransferModal() {
  const { rejectTransfer } = useTransferBookingContext();
  const goBack = useGoBack();
  const handleDeclineConfirmation = async () => {
    await rejectTransfer();
    goBack();
  };

  return (
    <Modal show onClose={goBack}>
      <ModalBody className={CSS.ModalBody}>
        <h1 className={CSS.Title}>Decline this transfer</h1>
        <Paragraph className={CSS.Paragraph}>
          <Strong weight="medium">Don't want to take this booking?</Strong> No
          worries, declining will not impact your performance statistics.
        </Paragraph>
        <Paragraph className={CSS.Paragraph}>
          <Strong weight="medium">Simply confirm your choice below.</Strong>
        </Paragraph>
        <RoundedButton size="S" onClick={handleDeclineConfirmation}>
          Decline transfer
        </RoundedButton>
        <RoundedButton size="S" inverted onClick={goBack}>
          Cancel
        </RoundedButton>
      </ModalBody>
    </Modal>
  );
}

export default DeclineTransferModal;
